import { Modal, notification } from 'antd'
import logoYellow from 'assets/img/logo-yellow.svg'
import logoWhite from 'assets/img/logo.svg'
import classnames from 'classnames'
import { Role } from 'models/enum'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { history } from 'router'
import { logout, setLoginModalVisible } from 'store/auth/auth.slice'
import {
  clearProfileList,
  getCompanyProfileList
} from 'store/general/entity.slice'
import { updateSessionProfile } from 'store/profile/companyprofile.slice'
import styles from '../Header.module.scss'
const { confirm } = Modal

const useHeader = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    role,
    userId,
    username,
    isLoggedIn,
    isUpdating,
    sessionCompanyProfileId
  } = useSelector((state) => state.auth)
  const { isCompanyProfileListLoading, companyProfileList } = useSelector(
    (state) => state.entity
  )
  const { hasDirtyFields: isEditingProfileData } = useSelector(
    (state) => state.profile
  )
  const [isMenuOpen, setMenuOpen] = useState(false)
  const handleToggleMenu = () => setMenuOpen(!isMenuOpen)
  const handleLogout = (e) => {
    e.preventDefault()
    dispatch(logout())
  }

  const handleOnLoginClick = (e) => {
    notification.close('session-expired')
    e.preventDefault()
    dispatch(setLoginModalVisible(true))
  }

  const isSysAdminMode = useMemo(() => {
    return role === Role.SysAdmin && !sessionCompanyProfileId
  }, [role, sessionCompanyProfileId])

  const headerClasses = useMemo(
    () =>
      classnames(styles.header, {
        [styles.open]: isMenuOpen,
        [styles.dark]: isLoggedIn && !isSysAdminMode
      }),
    [isLoggedIn, isMenuOpen, isSysAdminMode]
  )

  const logoSource = useMemo(() => {
    return isLoggedIn && !isSysAdminMode ? logoYellow : logoWhite
  }, [isLoggedIn, isSysAdminMode])

  const handleClickChangePassword = () => {
    history.push('/change-password')
  }

  useEffect(() => {
    if (role === Role.SysAdmin && isLoggedIn) {
      dispatch(getCompanyProfileList())
    }
    return () => dispatch(clearProfileList())
  }, [dispatch, role, isLoggedIn])

  const handleChangeProfile = (profileId) => {
    if (isEditingProfileData) {
      confirm({
        title: t('companyProfile.before-navigation'),
        onOk () {
          dispatch(updateSessionProfile(userId, profileId))
        },
        cancelText: t('general.cancel'),
        okText: t('general.yes')
      })
    } else {
      dispatch(updateSessionProfile(userId, profileId))
    }
  }

  const handleMenuItemClick = (event) => {
    if (event.target.getAttribute('role') === 'menuitem') {
      setMenuOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleMenuItemClick)
    return () => {
      document.removeEventListener('click', handleMenuItemClick)
    }
  }, [])

  return {
    role,
    username,
    isMenuOpen,
    isLoggedIn,
    isSysAdminMode,
    logoSource,
    isUpdating,
    headerClasses,
    companyProfileList,
    sessionCompanyProfileId,
    isCompanyProfileListLoading,
    handleLogout,
    handleToggleMenu,
    handleOnLoginClick,
    handleClickChangePassword,
    handleChangeProfile
  }
}

export default useHeader
